import React from 'react';
export var ModalContext = /*#__PURE__*/React.createContext({});
ModalContext.displayName = 'ModalContext';